<script>
    import SignIn from "../../Pages/Auth/SignIn.svelte";
</script>

<div class="flex flex-col flex-1 w-full align-left">
    <SignIn />
</div>
